<div class="footer_main_section">
    <div class="footer_top_section">
        <div class="footer_navbar_list">
            <div class="footer_inner_list">
                <div class="footer_box">
                    <a href="#" class="footer_logo"><img src="assets/images/logo-white.png" alt=""></a>
                    <p class="address_text">206 Graceland Blvd, Columbus, Ohio, 43214</p>
                    <div class="email_box">
                        <p class="email_text">EMAIL ID</p>
                        <p class="email_subtext">support@closedcaption.ai</p>
                    </div>
                    <div class="email_box">
                        <p class="email_text">CONTACT NUMBER</p>
                        <p class="email_subtext">(614) 888-7500</p>
                    </div>
                </div>
            </div>
            <div class="footer_inner_list">
                <div class="footer_box">
                    <h6 class="footer_heading">COMPANY</h6>
                    <ul class="footer_list mobile_mb_30">
                        <li><a [routerLink]="['./']">About closed caption.ai</a></li>
                        <li><a class="nav-link"  href="#features">Products</a></li>
                        <li><a class="nav-link" href="#pricing">Pricing</a></li>
                    </ul>
                </div>
                <div class="footer_box">
                    <h6 class="footer_heading">SERVICES</h6>
                    <ul class="footer_list mobile_mb_30">
                        <li><a [routerLink]="['./']">Audio Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Closed Caption Services</a></li>
                        <li><a [routerLink]="['./']">English Subtitle Services</a></li>
                        <li><a [routerLink]="['./']">Transcribe Audio to Text</a></li>
                        <li><a [routerLink]="['./']">Transcribe mp3 to Text</a></li>
                        <li><a [routerLink]="['./']">Global Subtitle Services</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer_inner_list">
                
                <div class="footer_box">
                    <h6 class="footer_heading">PRIVACY POLICY</h6>
                    <ul class="footer_list mobile_mb_30">
                        <li><a [routerLink]="['./']">Data Collection</a></li>
                        <li><a [routerLink]="['./']">Cookies and Tracking</a></li>
                        <li><a [routerLink]="['/terms-of-use']">Terms of Use</a></li>
                        <li><a [routerLink]="['/privacy-policy']">Policy Updates</a></li>
                        <li><a [routerLink]="['/']">User Information</a></li>
                    </ul>
                </div>
                <div class="footer_box">
                    <h6 class="footer_heading">SUPPORT</h6>
                    <ul class="footer_list mobile_mb_30">
                        <li><a [routerLink]="['./']"> Contact Sales</a></li>
                        <li><a [routerLink]="['./']"> Support Centre</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer_inner_list">
                <div class="footer_box">
                    <h6 class="footer_heading">INDUSTRIES</h6>
                    <ul class="footer_list mobile_mb_30">
                        <li><a [routerLink]="['./']">Marketing Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Media Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Academic Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Legal Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Medical Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Technology Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Research Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Financial Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Human Resources Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Real Estate Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Real Estate Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Customer Support Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Government Transcription Services</a></li>
                        <li><a [routerLink]="['./']">Hospitality Transcription Services</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer_inner_list">
                <div class="footer_box">
                    <h6 class="footer_heading">VIDEO FORMATS</h6>
                    <ul class="footer_list footer_list_mobile">
                        <li><a [routerLink]="['./']">.mp4 (MPEG-4 Part 14)</a></li>
                        <li><a [routerLink]="['./']">.avi (Audio Video Interleave)</a></li>
                        <li><a [routerLink]="['./']">.mov (QuickTime Movie)</a></li>
                        <li><a [routerLink]="['./']">.mkv (Matroska Video)</a></li>
                        <li><a [routerLink]="['./']">.wmv (Windows Media Video)</a></li>
                        <li><a [routerLink]="['./']">.flv (Flash Video)</a></li>
                        <li><a [routerLink]="['./']">.webm (WebM)</a></li>
                        <li><a [routerLink]="['./']">.m4v (MPEG-4 Video)</a></li>
                        <li><a [routerLink]="['./']">.3gp (3GPP Multimedia)</a></li>
                        <li><a [routerLink]="['./']">.rmvb (RealMedia Variable Bitrate)</a></li>
                        <li><a [routerLink]="['./']">.mpeg (MPEG Video)</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer_bottom_section">
        <p>Copyright © 2024 closedcaptions.ai. All rights reserved.”</p>
    </div>
</div>